import dayjs from 'dayjs';

/**
 * Форматирует DATE под TIME_ESTIMATION по формату
 * @param date - дата в виде строки
 * 12М 2н 3д 1ч 10м
 * превращает в минуты по формуле
 * ((mon*30 + w*7 + +d + Math.floor(h/8)) * 24 * 60 + h%8 * 60 + +m)
 * @returns { number, null }
 */
export function formatDATEtoTE(date: string | null | number): number | null {
    if (!date) return null;

    if (typeof date === 'number') return date;

    let m = 0, // минуты
        h = 0, // часы
        d = 0, // дни
        w = 0, // недели
        mon = 0; // месяц

    date.split(/\s+/).forEach((item) => {
        switch (item.slice(-1)) {
            case 'M':
            case 'М':
                mon = +item?.substring(0, item.length - 1);
                break;
            case 'm':
            case 'м':
                m = +item?.substring(0, item.length - 1);
                break;
            case 'h':
            case 'ч':
                h = +item?.substring(0, item.length - 1);
                break;
            case 'd':
            case 'д':
                d = +item?.substring(0, item.length - 1);
                break;
            case 'w':
            case 'н':
                w = +item?.substring(0, item.length - 1);
                break;
        }
    });
    return (mon * 30 + w * 7 + d + Math.floor(h / 8)) * 24 * 60 + (h % 8) * 60 + m;
}

/**
 * Форматирует TIME_ESTIMATION минуты  под DATE по формату
 * 1М 2н 3ч 1м
 * @param m - минуты
 * @returns { string, null }
 */
export function formatTEtoDATE(m: number | null): string | null {
    if (!m) return null;

    let value = dayjs.duration({
        minutes: m, //это чтобы привести 8 часовому рабочему дню
        hours: 0,
        days: 0,
        weeks: 0,
        months: 0,
        years: 0,
    });

    const months = value.months();

    value = value.subtract(dayjs.duration(months, 'M'));
    const weeks = value.weeks();

    value = value.subtract(dayjs.duration(weeks, 'w'));
    const days = value.days();

    value = value.subtract(dayjs.duration(days, 'd'));
    const hours = value.hours();

    value = value.subtract(dayjs.duration(hours, 'h'));
    const minutes = value.minutes();

    return (
        (months > 0 ? months + 'М ' : '') +
        (weeks > 0 ? weeks + 'н ' : '') +
        (days > 0 ? days + 'д ' : '') +
        (hours > 0 ? hours + 'ч ' : '') +
        (minutes > 0 ? minutes + 'м' : '')
    );
}

/**
 * Форматирует TIME_ESTIMATION минуты в дату
 * если пришли минуты, то обрабатываем в дату,
 * иначе если пришла дата, то передаем дату
 * @param params - число
 * @returns { number }
 */
export function teFormatter(params: { value?: string | number | null }): string | null {
    return params.value ? (typeof params.value === 'string' ? params.value : formatTEtoDATE(params.value)) : null;
}
